import React from "react"
import propTypes from "prop-types"

const UserButton = ({ name, onClick }) => {
  return (
    <a className="user-menu_button" onClick={e => onClick(e)} href="/#">
      {name.charAt(0).toUpperCase()}
    </a>
  )
}

UserButton.propTypes = {
  name: propTypes.string,
  onClick: propTypes.func.isRequired
}

UserButton.defaultProps = {
  name: ""
}

export default UserButton
